module.exports = __webpack_public_path__ + "static/media/proyeccion_card.63390667.png";